module.exports = __webpack_public_path__ + "media/images/motto-bg1-320-58a546646a150e8e7973c97d6c878928.png";